import './cookie-banner.css';

const STORAGE_KEY = 'cookieConsentAccepted';

export class CookieBannerClass {
  constructor() {
    this.banner = document.getElementById('cookie-banner');
    this.acceptButton = document.getElementById('cookie-banner-accept');

    if (!this.banner || !this.acceptButton) return;

    this.init();
  }

  init() {
    // Уже показывали и пользователь согласился — баннер больше не нужен.
    if (this.isAccepted()) return;

    this.show();

    this.acceptButton.addEventListener('click', () => {
      this.accept();
    });
  }

  isAccepted() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      // localStorage может быть недоступен (приватный режим, отключённые куки и т.п.).
      return false;
    }
  }

  show() {
    this.banner.classList.add('cookie-banner_visible');

    // Небольшая задержка, чтобы сработал transition появления.
    setTimeout(() => {
      this.banner.classList.add('cookie-banner_shown');
    }, 50);
  }

  accept() {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // Если хранилище недоступно — просто скрываем баннер в рамках сессии.
    }

    this.hide();
  }

  hide() {
    this.banner.classList.remove('cookie-banner_shown');

    setTimeout(() => {
      this.banner.classList.remove('cookie-banner_visible');
    }, 300);
  }
}
